import { call, put } from 'redux-saga/effects';
import { setUserDetails } from '../account/accountSlice';
import {
  requestConfirmPan,
  requestSavePanImage, requestSubmitPanNumber,
} from './panDetailsFormRequests';
import {
  setConfirmPan,
  setPanDetailsFormError, setPanDetailsFormStatus, setPanImageStatus, setPanVerificationData,
} from './panDetailsFormSlice';

export function* handleSavePanImage(action:any): Generator<any, any, any> {
  yield put(setPanDetailsFormStatus('loading'));

  try {
    const response = yield call(
      requestSavePanImage,
      { pan: action.payload.panCardImage }
    );
    const { data } = response;
    if (data.message === 'Details updated successfully') {
      yield put(setPanImageStatus({ isPanImageSaved: true }));
      yield put(setUserDetails({ ...data.user }));
    }
  } catch (error:any) {
    yield put(setPanDetailsFormError({
      isError: true,
      type: 'upload_pan',
      message: error?.response?.data?.message,
    }));
  }
}

export function* handleSubmitPanNumber(action:any): Generator<any, any, any> {
  yield put(setPanDetailsFormStatus('loading'));
  try {
    const { data } = yield call(
      requestSubmitPanNumber,
      { pan: action.payload.pan, dateOfBirth: action.payload.dateOfBirth }
    );
    if (data.message) {
      yield put(setPanVerificationData({ pan: action.payload.pan, dateOfBirth: action.payload.dateOfBirth }));
      yield put(setUserDetails(data.user));
    }
  } catch (error: any) {
    yield put(setPanDetailsFormError({
      isError: true,
      type: 'verify_pan',
      message: error?.response?.data?.message,
    }));
  }
}

export function* handleConfirmPan(): Generator<any, any, any> {
  yield put(setPanDetailsFormStatus('loading'));
  try {
    const { data } = yield call(requestConfirmPan);
    if (data) {
      yield put(setConfirmPan({ status: 'success', isConfirmPan: true }));
      yield put(setUserDetails(data.user));
    }
  } catch (error: any) {
    yield put(setConfirmPan({ status: 'failure', isConfirmPan: false }));
    yield put(setPanDetailsFormError({
      isError: true,
      type: 'confirm_pan',
      message: error?.response?.data?.message,
    }));
  }
}
